import React, { useState, useEffect, } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams, } from "react-router-dom";
import {
    Card,
    CardBody,
} from "../../../_metronic/_partials/controls";
import * as actions from "./_redux/Actions";

import moment from "moment";
import { Formik, } from "formik";
import './ContestList.css';
import * as UIHelpers from "../../components/UIHelpers";
import { NotificationContainer, NotificationManager } from "react-notifications";


export default function TotalJoinedPlayers(props) {

    const dispatch = useDispatch();

    const [idText, setIdText] = useState('');
    // const [passwordText, setPasswordText] = useState('');
    const [totalJoinedPlayers, setTotalJoinedPlayers] = useState(0);
    const [isDisabled, setIsdisabled] = useState(false);

    const { id } = useParams();
    const contestData = props.contestData

    useEffect(() => {

        // if (contestData && contestData.data.status && contestData.data.status === UIHelpers.CONTEST_STATUS.started) {
        if (contestData?.data?.numberOfPlayedUsers) {
            setTotalJoinedPlayers(contestData?.data?.numberOfPlayedUsers)
        }

        if(contestData.data?.numberOfPlayedUsers !== '' && contestData.data?.numberOfPlayedUsers > 0)
        {
            setIsdisabled(true)
        }
        else
        {
            if(contestData.data?.status == 'review')
            {
                setIsdisabled(false)
            }
            else
            {
                setIsdisabled(true)
            }
        }

    }, [contestData])

    const saveTotalJoinedPlayers = (props) => {
        // if (!listLoading) {
        //   setSearchApply(true);
        // console.log('id:', id)
        if(parseInt(totalJoinedPlayers) > 0)
        {
            let item = {}
            item.id = id
            item.totalJoinedPlayers = totalJoinedPlayers
            dispatch(actions.saveTotalJoinedPlayers(item)).then((sucess) => sucess ? window.location.reload() : null);
        }
        else 
        {
            NotificationManager.error('Please enter total played user number!', 'Error');
        }
        // }
    };
    return (

        contestData.data?.status == 'review' ?
            <Card className="card_border">
                <NotificationContainer />
                <div className="card-header p-0">
                    <div className="my-5 row mx-0 px-4 w-100 d-flex justify-content-between">
                        <div className="" style={{ fontSize: '24px', fontWeight: '600' }}>Total Played User</div>
                        {/* <div>{createFormInputs()}</div> */}
                    </div>
                </div>

                <CardBody className="p-2">

                    <div className="form-group row m-2">
                        {/* <div className="col p-2" style={{ maxWidth: '250px', }}>
              <label> ID</label>
              <input
                type="text"
                className="form-control"
                placeholder="ID"
                value={idText}
                disabled={contestData?.data?.roomId !== ''}
                onChange={(e) => { setIdText(e.target.value) }}
              />
            </div> */}

                        <div className="col p-2" style={{ maxWidth: '250px', }}>
                            <label>Total Played Users</label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Total Joined Players"
                                value={totalJoinedPlayers}
                                disabled={isDisabled}
                                onChange={(e) => { setTotalJoinedPlayers(e.target.value) }}
                            />
                        </div>

                        <div className="justify-content-end  col p-2">
                            {/* {console.log('contestData.data?.status:', contestData.data?.status)} */}
                            {
                                // contestData.data?.totalJoinedPlayers === '' || contestData.data?.totalJoinedPlayers <= 0 &&
                                // contestData.data?.status != 'review' ?
                                contestData.data?.numberOfPlayedUsers === '' || contestData.data?.numberOfPlayedUsers > 0 ?
                                <></>
                                :
                                <>
                                    <button type="submit" className="btn btn-dark"
                                        style={{ marginTop: "26px" }}
                                        onClick={() => { saveTotalJoinedPlayers() }}
                                    >
                                        Save
                                        {/* Search */}
                                    </button>
                                </>
                            }
                        </div>
                    </div>
                </CardBody>
            </Card>
            :
            <></>

    )
}